export default "__VITE_ASSET__mLcOrRPo__"